/**
 * The role feature that lets staff set who can see a booking: booking setup's own feature, held by internal roles
 * only. It also gates the Can see choice on Client Users and naming people on a booking. The API checks it on
 * every call (api/BookingAccess) and is staff only.
 */
export const BookingAccessFeature = 'BookingSetupView';